import { useCallback, useState } from "react";
import { parseMcpAuthRequest, McpAuthRequest } from "../lib/mcpAuth";

export interface UseMcpAuthRequest {
  /** The pending "connect Claude" request, or null when there is none or it was cancelled. */
  request: McpAuthRequest | null;
  /** Leave the consent flow. App renders the console in its place. */
  cancel: () => void;
}

/**
 * The pending account-mcp handoff (ENG-2209), held in state so Cancel can end it (ENG-3348).
 *
 * Cancel used to set `location.hash = ""`. That could not work. Since ENG-2630 the request comes from
 * INITIAL_HASH, the hash as the bundle loaded (see parseMcpAuthRequest), which no later URL change
 * touches, and App's hash sync has emptied the live hash long before this screen renders. So the click
 * changed nothing, and App re-derived the same request on its next render.
 *
 * Read once, on mount. INITIAL_HASH is frozen, so that is all the old per-render read ever saw: when
 * the consent screen appears is unchanged.
 */
export function useMcpAuthRequest(): UseMcpAuthRequest {
  const [request, setRequest] = useState<McpAuthRequest | null>(() => parseMcpAuthRequest());
  const cancel = useCallback(() => setRequest(null), []);
  return { request, cancel };
}
